/* Anime-Pass — collection page behaviour
   Sticky series-nav active state, highlight chips, and saved items.
   All progressive enhancement: without JS the pills are plain anchors,
   the chips are inert buttons, and the grid renders in full. */
(function () {
  'use strict';

  /* ---------- Highlight chips ---------- */
  function initChips(root) {
    var chips = root.querySelectorAll('[data-ap-chip]');
    var cards = root.querySelectorAll('[data-ap-tags]');
    if (!chips.length || !cards.length) return;
    var active = null;
    var statusEl = root.querySelector('[data-ap-chip-status]');

    function announceCount() {
      if (!statusEl) return;
      if (!active) {
        statusEl.textContent = '';
        return;
      }
      var visible = 0;
      cards.forEach(function (c) { if (!c.classList.contains('is-dimmed')) visible++; });
      statusEl.textContent = '';
      requestAnimationFrame(function () {
        statusEl.textContent = 'Showing ' + visible + ' of ' + cards.length + ' products.';
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var tag = chip.getAttribute('data-ap-chip').toLowerCase();
        var turningOff = active === tag;

        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', 'false');
        });
        active = turningOff ? null : tag;
        if (!turningOff) chip.setAttribute('aria-pressed', 'true');

        var grid = root.querySelector('.band-grid');
        if (!grid) return;

        var allCards = Array.from(cards);

        if (!active) {
          /* Reset: remove dimming and restore original order */
          allCards.forEach(function (card) {
            card.classList.remove('is-dimmed');
            card.style.order = '';
          });
        } else {
          var matchIndex = 0;
          var restIndex = allCards.length;

          allCards.forEach(function (card) {
            var cardTags = (card.getAttribute('data-ap-tags') || '').toLowerCase().split(',');
            var match = cardTags.some(function (t) {
              return t.trim() === active;
            });

            if (match) {
              card.classList.remove('is-dimmed');
              card.style.order = matchIndex++;
            } else {
              card.classList.add('is-dimmed');
              card.style.order = restIndex++;
            }
          });
        }

        announceCount();
      });
    });
  }

  /* ---------- Sticky series nav ---------- */
  function initSeriesNav(root) {
    var bands = root.querySelectorAll('[data-ap-band]');
    var pills = root.querySelectorAll('[data-ap-jump]');
    if (!bands.length || !pills.length) return;

    if (root._apBandObserver) {
      root._apBandObserver.disconnect();
      root._apBandObserver = null;
    }

    function setActive(id) {
      pills.forEach(function (p) {
        var on = p.getAttribute('data-ap-jump') === id;
        p.classList.toggle('active', on);
        if (on) {
          p.setAttribute('aria-current', 'true');
        } else {
          p.removeAttribute('aria-current');
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var topMost = null;
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            if (!topMost || e.boundingClientRect.top < topMost.boundingClientRect.top) {
              topMost = e;
            }
          });
          if (topMost) setActive(topMost.target.id);
        },
        { rootMargin: '-160px 0px -60% 0px', threshold: 0 }
      );
      bands.forEach(function (b) {
        io.observe(b);
      });
      root._apBandObserver = io;
    }

    pills.forEach(function (p) {
      if (p.getAttribute('data-ap-jump') !== 'top') return;
      p.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setActive('top');
      });
    });
  }

  /* ---------- Sort ---------- */
  function initSort(root) {
    var select = root.querySelector('[data-ap-sort]');
    if (!select) return;
    var form = select.closest('form');
    if (!form) return;
    var initial = select.value;
    select.addEventListener('change', function () { select._dirty = select.value !== initial; });
    select.addEventListener('blur', function () { if (select._dirty) form.submit(); });
    select.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); form.submit(); }
    });
  }

  function init(root) {
    initChips(root);
    initSeriesNav(root);
    initSort(root);
  }

  function boot() {
    document.querySelectorAll('[data-ap-collection]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ap-collection]');
    if (root) init(root);
  });
})();